export const FormError = ({ message, className = "" }) => {
  if (!message) return null;
  const text = Array.isArray(message)
    ? message.filter(Boolean).join("\n")
    : String(message);
  return (
    <div role="alert" className={`mt-2 text-danger text-sm ${className}`}>
      {text}
    </div>
  );
};

export default FormError;
